import React, { useState, useEffect } from 'react';
import { db, auth, storage } from '../firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, getDocs, addDoc, deleteDoc, doc, setDoc, updateDoc, query, orderBy, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import ScheduleModal from './ScheduleModal'; // Import the modal

function AdminReservasSedes() {
  const [sedes, setSedes] = useState([]);
  const [newSedeTitle, setNewSedeTitle] = useState('');
  const [newSedeImageUrl, setNewSedeImageUrl] = useState('');
  const [newSedeImageFile, setNewSedeImageFile] = useState(null);
  const [editingSedeId, setEditingSedeId] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentSedeId, setCurrentSedeId] = useState(null);
  const [currentSedeTitle, setCurrentSedeTitle] = useState('');

  const sedesCollectionRef = collection(db, 'reservasSedes');

  const handleOpenModal = (sedeId, sedeTitle) => {
    setCurrentSedeId(sedeId);
    setCurrentSedeTitle(sedeTitle);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentSedeId(null);
    setCurrentSedeTitle('');
    // Optionally refetch data
    getSedes(); 
  };

  const getSedes = async () => {
    try {
      const q = query(sedesCollectionRef, orderBy('createdAt', 'asc'));
      const data = await getDocs(q);
      const fetchedSedes = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setSedes(fetchedSedes);
    } catch (error) {
      console.error('Error al obtener sedes de reservas:', error);
      setMessage('Error al cargar las sedes de reservas.');
    }
  };

  const handleAddSede = async () => {
    if (newSedeTitle.trim() === '') return;

    try {
        let imageUrl = newSedeImageUrl;

        if (newSedeImageFile) {
            const imageRef = ref(storage, `reservasSedes/${Date.now()}_${newSedeImageFile.name}`);
            await uploadBytes(imageRef, newSedeImageFile);
            imageUrl = await getDownloadURL(imageRef);
        }

        await addDoc(collection(db, 'reservasSedes'), {
            title: newSedeTitle,
            imageUrl: imageUrl || '',
            isActive: true,
            schedule: { lunes: [], martes: [], miércoles: [], jueves: [], viernes: [], sábado: [], domingo: [] },
            createdAt: serverTimestamp()
        });
        setNewSedeTitle('');
        setNewSedeImageUrl('');
        setNewSedeImageFile(null);
        getSedes();
    } catch (e) {
        console.error("Error adding document: ", e);
        setError("Error al agregar la sede.");
    }
  };

  const handleUpdateSede = async () => {
    if (!editingSedeId || newSedeTitle.trim() === '') return;

    try {
        let imageUrl = newSedeImageUrl;

        if (newSedeImageFile) {
            const imageRef = ref(storage, `reservasSedes/${Date.now()}_${newSedeImageFile.name}`);
            await uploadBytes(imageRef, newSedeImageFile);
            imageUrl = await getDownloadURL(imageRef);
        }

        const sedeRef = doc(db, 'reservasSedes', editingSedeId);
        await updateDoc(sedeRef, {
            title: newSedeTitle,
            imageUrl: imageUrl
        });

        setEditingSedeId(null);
        setNewSedeTitle('');
        setNewSedeImageUrl('');
        setNewSedeImageFile(null);
        getSedes();
        setMessage('Sede actualizada correctamente.');
    } catch (e) {
        console.error("Error updating document: ", e);
        setError("Error al actualizar la sede.");
    }
  };

  const startEditing = (sede) => {
    setEditingSedeId(sede.id);
    setNewSedeTitle(sede.title);
    setNewSedeImageUrl(sede.imageUrl || '');
    setNewSedeImageFile(null);
  };

  const handleDeleteSede = async (id, imageUrl) => {
      if (!window.confirm("¿Estás seguro de que deseas eliminar esta sede?")) return;
      try {
          await deleteDoc(doc(db, 'reservasSedes', id));
          
          if (imageUrl && imageUrl.includes('firebase-storage')) {
              try {
                  const imageRef = ref(storage, imageUrl);
                  await deleteObject(imageRef);
              } catch (storageErr) {
                  console.error("Error deleting image from storage:", storageErr);
              }
          }
          
          getSedes();
      } catch (e) {
          console.error("Error deleting document: ", e);
          setError("Error al eliminar la sede.");
      }
  };

  const handleSetSedeStatus = async (sedeId, currentStatus) => {
    try {
        const sedeRef = doc(db, 'reservasSedes', sedeId);
        const data = {
            isActive: !currentStatus,
        };
        await setDoc(sedeRef, data, { merge: true }); // Use setDoc with merge to create/update
        alert(`Sede ${!currentStatus ? 'activada' : 'desactivada'} correctamente.`);
        getSedes();
    } catch (e) {
        console.error("Error setting sede status: ", e);
        setError("Error al cambiar el estado de la sede.");
        alert("Error al cambiar el estado de la sede.");
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        getSedes();
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);


  if (loading) {
    return <p>Cargando...</p>;
  }

  if (!user) {
    return <p>Debe iniciar sesión para gestionar las sedes de reservas.</p>;
  }

  return (
    <div style={{ marginBottom: '30px', padding: '20px', border: '1px solid #eee', borderRadius: '8px' }}>
      <h3>Gestionar Horarios de Reservas por Sede</h3>

      <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '400px' }}>
          <input
              type="text"
              value={newSedeTitle}
              onChange={(e) => setNewSedeTitle(e.target.value)}
              placeholder="Nombre de la sede"
              style={{ padding: '8px' }}
          />
          <input
              type="text"
              value={newSedeImageUrl}
              onChange={(e) => setNewSedeImageUrl(e.target.value)}
              placeholder="URL de Imagen (opcional)"
              style={{ padding: '8px' }}
          />
          <input
              type="file"
              onChange={(e) => setNewSedeImageFile(e.target.files[0])}
              style={{ padding: '8px' }}
          />
          <div style={{ display: 'flex', gap: '10px' }}>
            <button 
                onClick={editingSedeId ? handleUpdateSede : handleAddSede} 
                style={{ padding: '8px 12px', cursor: 'pointer', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px' }}
            >
                {editingSedeId ? 'Actualizar Sede' : 'Agregar Sede'}
            </button>
            {editingSedeId && (
                <button 
                    onClick={() => { setEditingSedeId(null); setNewSedeTitle(''); setNewSedeImageUrl(''); setNewSedeImageFile(null); }}
                    style={{ padding: '8px 12px', cursor: 'pointer', backgroundColor: '#ccc', border: 'none', borderRadius: '4px' }}
                >
                    Cancelar
                </button>
            )}
          </div>
      </div>

      {message && <p style={{ marginTop: '10px', color: 'green' }}>{message}</p>}
      {error && <p style={{ marginTop: '10px', color: 'red' }}>{error}</p>}

      <table className="admin-table">
          <thead>
              <tr>
                  <th>Imagen</th>
                  <th>Nombre de la Sede</th>
                  <th>Estado</th>
                  <th>Acciones</th>
              </tr>
          </thead>
          <tbody>
              {sedes.map(sede => (
                  <tr key={sede.id}>
                      <td>
                          {sede.imageUrl ? (
                              <img src={sede.imageUrl} alt={sede.title} style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }} />
                          ) : (
                              <div style={{ width: '50px', height: '50px', backgroundColor: '#eee', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px' }}>No img</div>
                          )}
                      </td>
                      <td>{sede.title}</td>
                      <td>{sede.isActive ? 'Activa' : 'Inactiva'}</td>
                      <td>
                          <button
                              onClick={() => handleSetSedeStatus(sede.id, sede.isActive)}
                              className={`action-button ${sede.isActive ? 'deactivate' : 'activate'}`}
                          >
                              {sede.isActive ? 'Desactivar' : 'Activar'}
                          </button>
                          <button 
                              onClick={() => startEditing(sede)}
                              className="action-button edit"
                              style={{ backgroundColor: '#2196F3', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', marginRight: '5px', cursor: 'pointer' }}
                          >
                              Editar
                          </button>
                          <button 
                              onClick={() => handleOpenModal(sede.id, sede.title)}
                              className="action-button schedule"
                          >
                              Horarios
                          </button>
                          <button
                              onClick={() => handleDeleteSede(sede.id, sede.imageUrl)}
                              className="action-button delete"
                          >
                              Eliminar
                          </button>
                      </td>
                  </tr>
              ))}
          </tbody>
      </table>

      {isModalOpen && (
        <ScheduleModal 
            sedeId={currentSedeId}
            sedeName={currentSedeTitle} // Pass title as name to the modal
            onClose={handleCloseModal} 
            firestoreCollection="reservasSedes" // Pass the collection name
        />
      )}
    </div>
  );
}

export default AdminReservasSedes;